import React from 'react';

function Icon({ name, ...props }) {
  const Item = require(`svg/${name}.svg`);

  return Item && <Item {...props} />;
}

export default React.memo(Icon);
